/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Choosewhat1Inputs */

const id_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih apa yang ingin Anda dapatkan notifikasinya:`)
};

const ms_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih apa yang anda mahu diberitahu:`)
};

const da_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg hvad du vil have besked om:`)
};

const de_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie, worüber Sie benachrichtigt werden möchten:`)
};

const en_us2_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what you want to be notified about:`)
};

const es_es2_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige sobre qué quieres recibir notificaciones:`)
};

const es_mx2_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige sobre qué quieres recibir notificaciones:`)
};

const fil_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili kung ano ang gusto mong maabisuhan:`)
};

const fr_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez ce pour quoi vous souhaitez être notifié :`)
};

const it_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli di cosa vuoi essere notificato:`)
};

const hu_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válaszd ki, miről szeretnél értesítést kapni:`)
};

const nl_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies waarover je meldingen wilt ontvangen:`)
};

const no_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg hva du vil varsles om:`)
};

const pl_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz, o czym chcesz otrzymywać powiadomienia:`)
};

const pt_br2_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what you want to be notified about:`)
};

const pt_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha sobre o que pretende ser notificado:`)
};

const ro_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alege despre ce dorești să fii notificat:`)
};

const fi_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse, mistä haluat ilmoituksia:`)
};

const sv_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj vad du vill bli notifierad om:`)
};

const vi_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn những gì bạn muốn được thông báo:`)
};

const tr_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne hakkında bildirim almak istediğinizi seçin:`)
};

const cs_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte, o čem chcete dostávat oznámení:`)
};

const bg_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете за какво искате да получавате известия:`)
};

const ru_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите, о чём вы хотите получать уведомления:`)
};

const uk_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть, про що ви хочете отримувати сповіщення:`)
};

const ar_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر ما تريد الإشعار به:`)
};

const hi_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चुनें कि आप किस बारे में सूचित होना चाहते हैं:`)
};

const th_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกสิ่งที่คุณต้องการรับการแจ้งเตือน:`)
};

const ja_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知を受け取りたいものを選択：`)
};

const zh_cn2_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what you want to be notified about:`)
};

const zh_hant1_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what you want to be notified about:`)
};

const ko_notifications_simple_choosewhat1 = /** @type {(inputs: Notifications_Simple_Choosewhat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림을 받을 항목을 선택하세요:`)
};

/**
* | output |
* | --- |
* | "Choose what you want to be notified about:" |
*
* @param {Notifications_Simple_Choosewhat1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_choosewhat1 = /** @type {((inputs?: Notifications_Simple_Choosewhat1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Choosewhat1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_choosewhat1(inputs)
	if (locale === "ms") return ms_notifications_simple_choosewhat1(inputs)
	if (locale === "da") return da_notifications_simple_choosewhat1(inputs)
	if (locale === "de") return de_notifications_simple_choosewhat1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_choosewhat1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_choosewhat1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_choosewhat1(inputs)
	if (locale === "fil") return fil_notifications_simple_choosewhat1(inputs)
	if (locale === "fr") return fr_notifications_simple_choosewhat1(inputs)
	if (locale === "it") return it_notifications_simple_choosewhat1(inputs)
	if (locale === "hu") return hu_notifications_simple_choosewhat1(inputs)
	if (locale === "nl") return nl_notifications_simple_choosewhat1(inputs)
	if (locale === "no") return no_notifications_simple_choosewhat1(inputs)
	if (locale === "pl") return pl_notifications_simple_choosewhat1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_choosewhat1(inputs)
	if (locale === "pt") return pt_notifications_simple_choosewhat1(inputs)
	if (locale === "ro") return ro_notifications_simple_choosewhat1(inputs)
	if (locale === "fi") return fi_notifications_simple_choosewhat1(inputs)
	if (locale === "sv") return sv_notifications_simple_choosewhat1(inputs)
	if (locale === "vi") return vi_notifications_simple_choosewhat1(inputs)
	if (locale === "tr") return tr_notifications_simple_choosewhat1(inputs)
	if (locale === "cs") return cs_notifications_simple_choosewhat1(inputs)
	if (locale === "bg") return bg_notifications_simple_choosewhat1(inputs)
	if (locale === "ru") return ru_notifications_simple_choosewhat1(inputs)
	if (locale === "uk") return uk_notifications_simple_choosewhat1(inputs)
	if (locale === "ar") return ar_notifications_simple_choosewhat1(inputs)
	if (locale === "hi") return hi_notifications_simple_choosewhat1(inputs)
	if (locale === "th") return th_notifications_simple_choosewhat1(inputs)
	if (locale === "ja") return ja_notifications_simple_choosewhat1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_choosewhat1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_choosewhat1(inputs)
	return ko_notifications_simple_choosewhat1(inputs)
});
export { notifications_simple_choosewhat1 as "notifications.simple.chooseWhat" }